import { mapGetters } from 'vuex';
import profile from '@/components/account/profile/profile.vue';
import store from '@/store';
import accountVerifyMixin from '@/mixins/accountVerify';

function getDefaultRedirectRouteName(isWalletAvailable) {
  return isWalletAvailable ? 'wallet' : 'account-history';
}


export default {
  mixins: [
    accountVerifyMixin,
  ],
  components: {
    profile,
  },
  watch: {
    isLayoutMobile(value) {
      if (!value) {
        // const isWalletAvailable = this.isUserVerified && !this.hasMaintenanceMessage;
        this.$router.push({ name: getDefaultRedirectRouteName(this.isWalletEnabled) });
      }
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('app', ['hasMaintenanceMessage']),
  },
  beforeCreate() {
    // because router.beforeEnter() fires before app.resizeHandler() can check client width
    // also this.isLayoutMobile === undefined here
    if (store.state.app.layout === 'desktop') {
      const idVerified = store.state.user.status.idVerified;
      const isUserVerified = (typeof idVerified !== 'undefined') ? idVerified : true;
      // const isMaintenanceEnabled = store.getters['app/hasMaintenanceMessage'];
      // const isWalletAvailable = isUserVerified && !isMaintenanceEnabled;
      this.$router.push({ name: getDefaultRedirectRouteName(isUserVerified) });
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/account/profile-page/profile-page.js